import React from 'react';
import {
  getFormattedArrivalDate,
  getFormattedDepartureDate,
  getTotalPriceFormatted,
} from 'Utils/proposal/proposalUtils';
import {
  getInboundDeparture,
  getOutboundDeparture,
  getTravelSectionBoundSummary,
} from 'Utils/transport/transportUtils';
type Props = {
  dateFormat?: string;
  id?: string | null | undefined;
  layerTitle: string;
  numberResults?: number;
  proposal: Proposal;
  totalPrice?: string;
};

const getTransportSummary = (proposal: Proposal): string => {
  const currentTransport = proposal.transports;
  const inboundDeparture = getInboundDeparture(currentTransport);
  const outboundDeparture = getOutboundDeparture(currentTransport);
  const departureSummary = getTravelSectionBoundSummary(inboundDeparture);
  const arrivalSummary = getTravelSectionBoundSummary(outboundDeparture);
  return departureSummary && arrivalSummary ? `${departureSummary} - ${arrivalSummary}` : '';
};

const getProposalSummary = (proposal, dateFormat): string => {
  const arrivalDate = getFormattedArrivalDate(proposal, dateFormat);
  const departureDate = getFormattedDepartureDate(proposal, dateFormat);
  return `${arrivalDate} - ${departureDate}`;
};

export const LayerHeaderProposal = ({
  dateFormat,
  id,
  layerTitle = '',
  numberResults,
  proposal,
  totalPrice = '',
}: Props) => {
  const summary = proposal.transports
    ? getTransportSummary(proposal)
    : getProposalSummary(proposal, dateFormat);
  return (
    <div className="mx-10 flex items-end justify-between gap-10 text-mediumGrey">
      <span className="hidden text-16 font-bold lg:block" data-testid="LayerHeaderProposal-summary">
        {summary}
      </span>
      <span
        className="flex flex-1 items-center justify-center gap-5 font-sans text-20 font-semibold leading-tight text-black"
        data-testid="LayerHeaderProposal-title"
        id={id}
      >
        {layerTitle}
        {numberResults && <span className="text-12">({numberResults})</span>}
      </span>
      <span className="hidden items-end gap-10 text-16 font-bold md:flex">
        <span data-testid="LayerHeaderProposal-totalLabel">{totalPrice}</span>
        <span className="text-20 text-sienna" data-testid="LayerHeaderProposal-total">
          {getTotalPriceFormatted(proposal)}
        </span>
      </span>
    </div>
  );
};
